__turbopack_context__.v({
  "dialog": "Hb8cKW_dialog",
  "dialog__content": "Hb8cKW_dialog__content",
  "dialog__footer": "Hb8cKW_dialog__footer",
  "dialog__header": "Hb8cKW_dialog__header",
  "dialog__loading-area": "Hb8cKW_dialog__loading-area",
  "dialog__title": "Hb8cKW_dialog__title",
});
